import React, { useEffect, useMemo, useRef, useState } from "react";
import { InfiniteList2, OptionsPanelContainer } from "../../../../../../../common/components";
import { translate, translateDate } from "../../../../../../../common/providers";
import { ApiService, FeatureManagementService } from "../../../../../../../api";
import Box from "../../../../box/Box";
import { isEqual, isNonEmptyArray } from "../../../../../../../common/utils";
import styles from "./ProjectList.module.css";

export default function ProjectList({ feat: { id }, onUpdateRow, projectsRequest }) {
	const cancelTokenSourceRef = useRef();
	const [projects, setProjects] = useState([]);
	const [tempProjects, setTempProjects] = useState([]);
	useEffect(() => {
		cancelTokenSourceRef.current = ApiService.getCancelTokenSource();
		FeatureManagementService.getActiveFeatureProjects({ featureId: id }, cancelTokenSourceRef.current.token).then(
			(data) => {
				const safeData = isNonEmptyArray(data) ? data : [];
				setProjects(safeData);
				setTempProjects(safeData);
			}
		);
		return () => {
			ApiService.cancelTokens(cancelTokenSourceRef.current);
		};
	}, [id]);
	const handleCheck = (data, checked) => {
		if (checked) {
			setTempProjects((prev) => prev.filter((tcp) => tcp.id !== data.id));
		} else {
			setTempProjects((prev) => [...prev, data]);
		}
	};
	const handleReset = () => {
		setTempProjects(projects);
	};

	const handleSave = () => {
		const toAdd = tempProjects.filter((tc) => !projects.some((c) => c.id === tc.id)).map((ta) => ta.id);
		const toRemove = projects.filter((tc) => !tempProjects.some((c) => c.id === tc.id)).map((ta) => ta.id);
		FeatureManagementService.updateActiveFeatureProjects(
			{ featureId: id },
			{
				toAdd: isNonEmptyArray(toAdd) ? toAdd : undefined,
				toRemove: isNonEmptyArray(toRemove) ? toRemove : undefined,
			},
			cancelTokenSourceRef.current.token
		).then(() => {
			setProjects(tempProjects);
			onUpdateRow(id, "companies", tempProjects.length);
		});
	};
	const hasDiff = useMemo(
		() =>
			isEqual(
				projects.map((x) => x.id),
				tempProjects.map((x) => x.id)
			),
		[projects, tempProjects]
	);
	const rowRenderer = (row) => (
		<Box
			key={row.id}
			checked={tempProjects.some((p) => p.id === row.id)}
			content={translateDate(row.created)}
			data={row}
			id={row.id}
			title={row.name}
			onCheck={handleCheck}
		/>
	);
	return (
		<OptionsPanelContainer
			buttonText={translate("common:btn.save")}
			buttonTextSecondary={translate("common:btn.cancel")}
			disabledPrimaryButton={hasDiff}
			disabledSecondaryButton={hasDiff}
			onClick={handleSave}
			onClickSecondary={handleReset}
		>
			<InfiniteList2 hasSearch className={styles.container} request={projectsRequest} rowRenderer={rowRenderer} />
		</OptionsPanelContainer>
	);
}
